export default "__VITE_ASSET__17d2c9a7__"